<div class="w-full flex-column  flex justify-content-center align-items-center">
  <h1>Esta página no fue encontrada</h1>
  <div class="flex">
    <div>
      <p-button
        styleClass="p-button-lg p-button-rounded p-button-info p-button-text"
        [routerLink]="['/']"
    >Home</p-button>
    </div>
  </div>
</div>

